export interface TsAppVersion {
    version: string;
    name: string;
    description?: string;
    versionLong?: string;
    versionDate: string;
    gitCommitHash?: string;
    gitCommitDate?: string;
    gitTag?: string;
};

export const versions: TsAppVersion = {
    version: '2.8.1',
    name: 'fpar',
    versionDate: '2026-07-21T12:21:09.508Z',
};
export default versions;
